const KonsolScopes = [
    "list:database",
    "create:deliverables",
    "delete:deliverables",
    "read:deliverables",
    "update:deliverables",
    "write:deliverables",
    "read:fdl",
    "read:eula",
    "read:illusion",
    "write:illusion",
    "update:illusion",
    "read:konsol",
    "delete:metadata",
    "read:metadata",
    "write:metadata",
    "read:media",
    "track:media",
    "transfer:media",
    "update:media",
    "verify:media",
    "write:media",
    "read:notification",
    "write:notification",
    "read:project",
    "update:project",
    "assign:roles",
    "read:roles",
    "create:source",
    "delete:source",
    "read:source",
    "update:source",
    "read:storage",
    "update:user",
    "read:users",
    "create:users",

].join(" ")

export { KonsolScopes }